import { render, staticRenderFns } from "./CrossSelling.vue?vue&type=template&id=15c2e158&scoped=true"
import script from "./CrossSelling.vue?vue&type=script&lang=js"
export * from "./CrossSelling.vue?vue&type=script&lang=js"
import style0 from "./CrossSelling.vue?vue&type=style&index=0&id=15c2e158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c2e158",
  null
  
)

export default component.exports